<template>
<v-progress-circular
  color='success' width='3' size='26'
  v-if='value === 100' :value='value' >
  <v-icon small >check</v-icon>
</v-progress-circular>
<v-icon v-else-if='value === 0' color='error'>warning</v-icon>
<v-progress-circular
  color='primary' width='3' size='26'
  v-else :value='value' >
  {{percent}}
</v-progress-circular>
</template>
<script>
export default {
  name: 'AdherenceProgress',
  props: {
    value: { required: true, type: Number }
  },
  computed: {
    percent () {
      if (this.value) {
        return Math.round(this.value)
      }
      return 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// AdherenceProgress.vue?16e86f71